/**
 * @file 快速开始组件
 * @author FengGuang(fengguang01@baidu.com)
 *
 */

import React, { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import classNames from 'classnames';
import { Button, message, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';


import { IQuickStartProps } from './type';
import MarkdownContainer from '../../../../components/markdown-container/MarkdownContainer';
import { getCodeBlock } from '../../../../components/markdown-container/CodeBlock';


const QuickInstall: React.FC<IQuickStartProps> = React.memo(props => {
    const {
        trackeventOptLabel,

        quickInstallSelector,
        checked,
        disabled,
        showItem,

        handleOnItemChange
    } = props;

    const contentRef = useRef<HTMLDivElement>(null);

    const [isPushedTrackevent, setIsPushedTrackevent] = useState<boolean>(false);

    // 如果有展示信息，则触发一次埋点事件
    useEffect(() => {
        if (!isPushedTrackevent && (window as any)._hmt && showItem) {
            (window as any)._hmt.push(['_trackEvent', '安装', '快速安装,方案生成', trackeventOptLabel]);
            setIsPushedTrackevent(true);
        }
    }, [isPushedTrackevent, showItem, trackeventOptLabel]);

    // 如果选项变化，则触发一次埋点事件
    useEffect(() => {
        if ((window as any)._hmt && showItem) {
            (window as any)._hmt.push(['_trackEvent', '安装', '快速安装,方案选择', JSON.stringify(checked)]);
        }
    }, [checked, showItem]);

    // 查看国产芯片，触发点击事件
    useEffect(() => {
        if ((window as any)._hmt && contentRef.current) {
            const dom = contentRef.current;
            const aList: HTMLAnchorElement[] = Array.from(dom.querySelectorAll('a'));
            const handleClick = (event: MouseEvent) => {
                const aDom: HTMLAnchorElement | null = event.target as HTMLAnchorElement;
                const url = aDom?.href || '';
                if (url) {
                    (window as any)._hmt.push([
                        '_trackEvent',
                        '安装',
                        '快速安装,查看全部安装步骤',
                        JSON.stringify({
                            '链接': url,
                            '选项': checked
                        })]);
                }
            };
            const targetList = aList.filter((aDom) => {
                return aDom.innerHTML.includes('查看麒麟')
                    || aDom.innerHTML.includes('查看兆芯')
                    || aDom.innerHTML.includes('查看普华')
                    || aDom.innerHTML.includes('查看龙芯');
            });
            targetList.forEach((aDom) => {
                aDom.addEventListener('click', handleClick);
            });
            return () => {
                targetList.forEach((aDom) => {
                    aDom.removeEventListener('click', handleClick);
                });
            }
        }
    }, [showItem, checked]);

    // 之前的逻辑，获取哪些块需要设置为 checked 的逻辑
    // const checkedSet = useMemo(() => {
    //     return new Set(checked);
    // }, [checked]);

    // 现在的逻辑，增加判断使用了 showItem.indexSet作为块是否设置为checked
    const checkedSet = useMemo(() => {
        if (showItem && showItem.indexSet) {
            return new Set(showItem.indexSet);
        }
        return new Set(checked);
    }, [checked, showItem]);

    const disabledSet = useMemo(() => {
        return new Set(disabled);
    }, [disabled]);

    const onMarkdownCopyClick = useCallback((text?: string) => {
        if (!text) {
            return;
        }
        const text2 = text.length > 20 ? `${text.slice(0, 20)}...` : text;
        message.info(`${text2} 已复制到剪贴板`);
        if (text.includes(' install ') || text.includes('docker pull')) {
            // 如果点击复制按钮，则触发一次埋点事件
            if ((window as any)._hmt) {
                (window as any)._hmt.push([
                    '_trackEvent',
                    '首页',
                    '快速安装,方案生成',
                    JSON.stringify({
                        '安装命令': text,
                        '选项': checked
                    })
                ]);
            }
        }
    }, [checked]);

    return (
        <div className="paddle-quick-start">
            {
                quickInstallSelector.length > 0
                && <div className="paddle-quick-start-content">
                    {quickInstallSelector.map(group => (
                        <div key={group.groupKey} className="paddle-quick-start-item">
                            <div className="paddle-quick-start-item-title">
                                {group.groupName}
                                {!!group.tips
                                    && (
                                        <Tooltip
                                            overlayClassName="paddle-quick-start-item-tip"
                                            placement="bottom"
                                            title={group.tips}
                                        >
                                            <QuestionCircleOutlined className="paddle-quick-start-item-title-tip-icon" />
                                        </Tooltip>
                                    )}
                            </div>
                            <div className="paddle-quick-start-item-children">
                                <Button.Group size="large">
                                    {(() => {
                                        // const allOptionKey = group.list.map(item => item.optionKey);

                                        // if (allOptionKey.every(item => disabledSet.has(item))) {
                                        //     return (
                                        //         <Button
                                        //             // key={btnItem.optionKey}
                                        //             className={classNames({
                                        //                 // large: arr.length <= 2,
                                        //                 // checked: true,
                                        //                 disabled: true
                                        //             })}
                                        //             disabled={true}
                                        //         >
                                        //             无计算平台
                                        //         </Button>
                                        //     );
                                        // }

                                        return group.list.map((btnItem, btnItemIndex, arr) => {
                                            if (disabledSet.has(btnItem.optionKey) && group.groupName === '计算平台') {
                                                return null;
                                            }
                                            
                                            // let isDisabled = group.groupName !== '芯片厂商' && disabledSet.has(btnItem.optionKey);
                                            let isDisabled = false;
                                            // let isDisabled = disabledSet.has(btnItem.optionKey);
                                            // console.log('get dddddd');
                                            // console.log(btnItem);
                                            // console.log(checkedSet);
                                            // console.log(group.groupName);
                                            // console.log(disabledSet);
                                            // if (group.groupName !== '飞桨版本' || Array.from(allCheckedSet).includes('macos')) {
                                            if (group.groupName !== '飞桨版本') {
                                                isDisabled = disabledSet.has(btnItem.optionKey);
                                            }

                                            return (
                                                <Tooltip
                                                    key={btnItem.optionKey}
                                                    overlayClassName="paddle-quick-start-item-tip"
                                                    placement="top"
                                                    title={
                                                        disabledSet.has(btnItem.optionKey) ? group.disabledTooltip : undefined
                                                    }
                                                >
                                                    <Button
                                                        key={btnItem.optionKey}
                                                        className={classNames({
                                                            large: arr.length <= 2,
                                                            checked: checkedSet.has(btnItem.optionKey),
                                                            disabled: isDisabled
                                                        })}
                                                        disabled={isDisabled}
                                                        onClick={event =>
                                                            handleOnItemChange(event, group.groupKey, btnItem.optionKey)
                                                        }
                                                    >
                                                        {btnItem.optionName}
                                                    </Button>
                                                </Tooltip>
                                            );
                                        });
                                    })()}
                                </Button.Group>
                            </div>
                        </div>
                    ))}
                </div>
            }
            {
                !!showItem?.context
                && <div className="paddle-quick-start-result" ref={contentRef}>
                    {showItem.context.map(item => (
                        <div className="paddle-quick-start-result-item" key={item.title}>
                            <div className="paddle-quick-start-result-title">
                                {item.title}
                            </div>
                            <div className="paddle-quick-start-result-text">
                                <MarkdownContainer
                                    source={item.text}
                                    renderers={{
                                        code: getCodeBlock({
                                            onCopyClick: onMarkdownCopyClick
                                        })
                                    }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            }
        </div>
    );
});

export default QuickInstall;
